import { Howl } from "howler";
import { useEffect } from "react";
import { randomArrayElement } from "./utils";

const NOTIFICATIONS = [
  {
    sound: new Howl({ src: "/notifications/notif1.webm" }),
    rates: [
      1, // 1109
      1.3345356177, // 1480
      0.7489630298, // 830.6
      0.5611361587, // 622.3
    ],
  },
  {
    sound: new Howl({ src: "/notifications/notif2.webm" }),
    rates: [
      1, // 1976
      1.2596153846, // 2489
      0.7489630298, // 1480
      0.5611361587, // 1109
    ],
  },
  {
    sound: new Howl({ src: "/notifications/notif3.webm" }),
    rates: [
      1, // 1661
      1.3347381096, // 2217
      0.7489630298, // 1245
      0.5000602047, // 830.6
    ],
  },
];

export function playRandomNotification() {
  const { sound, rates } = randomArrayElement(NOTIFICATIONS);
  const rate = randomArrayElement(rates);

  sound.rate(rate, sound.play());
}

export function useRandomNotification(dependencies: any[] = []) {
  useEffect(() => {
    // The timeout is here to prevent the notification from playing multiple times at the same time
    // in development
    const timeout = setTimeout(() => playRandomNotification());
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
